import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaMedium,
  FaGithub,
} from "react-icons/fa";
import { logo } from "../../assets/index";
import { navLinksdata } from "../../constants";
import { Link } from "react-scroll";

const Footer = () => {
  return (
    <div className="w-full py-20 h-auto border-b-[1px] flex flex-col items-center justify-center border-b-black gap-8">
      <div className="w-full h-full flex flex-col items-center gap-8">
        <img className="w-32" src={logo} alt="logo" />
        <ul className="flex flex-row gap-4">
          {navLinksdata.map((item) => (
            <li
              key={item._id}
              className="text-base font-normal text-gray-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
            >
              <Link
                activeClass="active"
                to={item.link}
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
        <div className="flex gap-4">
          <a className="bannerIcon" href="https://github.com/Shravan250">
            <FaGithub />
          </a>
          <a
            className="bannerIcon"
            href="https://medium.com/@shravan.bobade.tech"
          >
            <FaMedium />
          </a>
          <a className="bannerIcon" href="www.linkedin.com/in/shravan-bobade">
            <FaLinkedinIn />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
